import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable, Subscription, filter, map, take } from 'rxjs';

import { Modal } from 'bootstrap';

import { subtractDateTime } from '@/_utils/subtract-date-time';
import { Data2Service } from './data2.service';

@Component({
	selector: 'app-filters',
	template: '',
	standalone: true,
})
export class FiltersComponent implements OnInit, OnDestroy {
	@Input() modalId = 'filtersModal';
	@Input() filters: Params;
	@Input() userFilters: string;
	@Input() forceFilters: Params;

	@Output() filtersChange = new EventEmitter();
	@Output() selected = new EventEmitter();

	protected filtersDefinition = {};

	private queryParamsSubscription: Subscription;

	constructor(
		protected api: Data2Service,
		protected route: ActivatedRoute,
		protected router: Router,
	) {}

	ngOnInit(): void {
		this.queryParamsSubscription = this.route.queryParams.subscribe((params) => {
			if (!params || Object.keys(params).length === 0) {
				this.filtersLoad();
				return;
			}
			for (const key in params) {
				this.filters[key] = this.convertParm(key, params[key]);
			}
			this.filtersAfterLoad();
			this.filtersForce();
			this.selected.emit(this.filters);
		});
	}

	ngOnDestroy(): void {
		this.queryParamsSubscription?.unsubscribe();
	}

	filtersDefault(): void {
		console.warn('filtersDefault fn not implemented!');
	}

	filtersClear(): void {
		for (const key in this.filters) {
			if (Array.isArray(this.filters[key])) {
				this.filters[key] = [];
				continue;
			}
			this.filters[key] = null;
		}
	}

	filtersOpen(): void {
		const modal = Modal.getInstance(document.getElementById(this.modalId));
		if (!modal) {
			new Modal(document.getElementById(this.modalId)).show();
		} else {
			modal.show();
		}
	}

	filtersClose(): void {
		const modal = Modal.getInstance(document.getElementById(this.modalId));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	filtersSave(): void {
		this.fulters2url(this.filters);
		this.filtersClose();
		this.api.put('/userFilters/' + this.userFilters, this.filters, () => {
			// this.selected.emit(this.filters);
		});
	}

	convertParm(key: string, value: string | string[]): string | string[] | number | number[] {
		if (value instanceof Array) {
			return value.map((singleValue) => {
				return <string>this.parseInt(key, singleValue);
			});
		}
		if (this.filtersDefinition[key] && this.filtersDefinition[key].isArray) {
			return [<string>this.parseInt(key, value)];
		}

		if (
			this.filtersDefinition[key] &&
			!this.filtersDefinition[key].isArray &&
			this.filtersDefinition[key].type === 'boolean'
		) {
			return <string>this.parseBoolean(key, value);
		}

		return this.parseInt(key, value);
	}

	protected filtersAfterLoad(): void {
		console.warn('filtersAfterLoad not implemented!');
	}

	protected filtersLoad(): void {
		this.filtersDefault();
		this.api.get('/userFilters/' + this.userFilters, (result) => {
			if (result.data && !(result.data instanceof Array)) {
				this.filters = result.data;
			}
			this.fulters2url(this.filters);
		});
	}

	protected checkQueryParamsAndReturnSevenDaysBeforeDate(): Observable<Date> {
		return this.route.queryParams.pipe(
			take(1),
			filter((queryParams) => {
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				const { on, limit, ...filteredParams } = queryParams;
				return !Object.keys(filteredParams).some(
					(key) => !(Array.isArray(filteredParams[key]) && filteredParams[key].length === 0),
				);
			}),
			map(() => subtractDateTime(new Date(), { days: 7 })),
		);
	}

	private filtersForce(): void {
		if (this.forceFilters === undefined) {
			return;
		}
		for (const key in this.forceFilters) {
			this.filters[key] = this.forceFilters[key];
		}
	}

	private fulters2url(filters: Params): void {
		if (!filters || filters instanceof Array) {
			this.selected.emit({});
			return;
		}

		filters.on = 1; // hack when no filters selected
		this.router.navigate(['.'], {
			relativeTo: this.route,
			queryParams: filters,
			preserveFragment: true,
			replaceUrl: true,
		});
	}

	private parseInt(key: string, value: string): number | string {
		if (this.filtersDefinition[key] && this.filtersDefinition[key].type == 'number') {
			return parseInt(value);
		}
		return value;
	}

	private parseBoolean(key: string, value: string): boolean | string {
		if (this.filtersDefinition[key] && this.filtersDefinition[key].type == 'boolean') {
			return value === 'true' ? true : value === 'false' ? false : '';
		}
		return value;
	}
}
